import React, {useContext, useEffect, useState} from "react";
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import Layout from "../../../components/sales/layout/layout";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
const WalletApprovalListing = ({
        match,             
        approvalList,
        approvalListDetails = []
}) => {

    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [listData, setListData] = useState();

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await approvalList(match.params.wallet_id,1, match?.params?.sub_category)
            setIsLoading(false)
        })()
    }, [match.params.wallet_id])

    console.log(match?.params?.sub_category)
    const headers = [
        'Request Amount',
        'Wallet Added Amount',
        match?.params?.sub_category === undefined ? 'Partner Name' : "Category Name",
        match?.params?.sub_category === undefined ? '' : "Sub-Category Name",
        'Created At',
        'Manager Remark',
        'Manager Action Date',
        'Finance Remark',
        'Finance Action Date',
        'Status',
        'Action'
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        await approvalList(match.params.wallet_id, val.selected + 1, match?.params?.sub_category);
        setIsLoading(false);
    };

    useEffect(() => {
        if (approvalListDetails &&
            approvalListDetails?.data !== undefined && approvalListDetails?.data.length > 0) {
            const tableData = ['id', 'amount', 'new_money', 'category_name' ,'subcategory', 'created_at', 'intermediate_remark' ,'approved_rejected_date', 'finance_remark' , 'finance_date', 'status'];
            const data = approvalListDetails?.data.map((element) =>
                Object.assign(
                    ...tableData.map((key) => (
                        key === 'status' && parseInt(element['status']) === 1 ? {[key]: 'Manager Pending'} :
                        key === 'status' && parseInt(element['status']) === 2 ? {[key]: 'Finance Pending'} :
                        key === 'status' && parseInt(element['status']) === 3 ? {[key]: 'Manager Rejected'} :
                        key === 'status' && parseInt(element['status']) === 4 ? {[key]: 'Finance Approved'} :
                        key === 'status' && parseInt(element['status']) === 5 ? {[key]: 'Finance Rejected'} :
                        {[key]: element[key]}
                    )),
                    {
                        Action:[
                            {name:'View details', link:`${baseUrl}/wallet/request-view/wallet_id`},
                        ]
                    },
                )
            )
            if (data) {
                data && setListData(data);
            }
            setPageCount(Math.ceil(approvalListDetails.total / approvalListDetails.per_page));
        }
    }, [approvalListDetails])

    return (
        <>
            <Layout
                title={localization.transactionRequest}
                isLoading={isLoading}
                isGoback={true}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={approvalListDetails?.data && approvalListDetails?.data}
                    srNo={approvalListDetails?.from}
                />
            </Layout>
        </>
    )
}

export default WalletApprovalListing

